webpackJsonp([156189486563066],{

/***/ 1415:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"name":"CustomClientFieldValueInput","kind":"INPUT_OBJECT","type":"OBJECT","fields":[{"defaultValue":null,"description":null,"name":"clientId","type":{"kind":"SCALAR","name":"ID","ofType":null}},{"defaultValue":null,"description":null,"name":"customClientFieldId","type":{"kind":"SCALAR","name":"ID","ofType":null}},{"defaultValue":null,"description":null,"name":"value","type":{"kind":"SCALAR","name":"String","ofType":null}}],"description":null,"enumValues":null,"possibleTypes":null}}

/***/ })

});


// WEBPACK FOOTER //
// path---input-object-custom-client-field-value-input-d98801b6f9303bbd99e3.js